const widgetMinimize = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.934 8.189v5.501l-2.17-2.158-.128-.126L3.033 14 2 12.911l.07-.07 2.503-2.493-2.172-2.16zM12.937 2 14 3.059l-2.56 2.548.133.131 2.174 2.163H8.214V2.399l2.162 2.15z"/></svg>',
};

export { widgetMinimize as default };
